/**
 * PDF Templates Index
 *
 * Central export point for all PDF templates across all languages.
 * Provides utility functions for querying and filtering templates.
 */

// Import English templates
import {
  advisoryMultiPortfolioStandard as advisoryMultiPortfolioStandardEnGB,
  helloWorld as helloWorldEnGB,
} from "./en_GB";
// Import Norwegian templates
import {
  advisoryMultiPortfolioStandard as advisoryMultiPortfolioStandardNbNO,
  helloWorld as helloWorldNbNO,
} from "./nb_NO";
import type { PdfTemplate, PdfTemplateCategory } from "./types";

// Export types
export type {
  PdfTemplate,
  PdfTemplateCategory,
  PdfTemplateComponent,
  PdfTemplatePage,
  PdfTemplateSection,
} from "./types";

/**
 * All available PDF templates
 */
export const PDF_TEMPLATES: PdfTemplate[] = [
  // English templates
  helloWorldEnGB,
  advisoryMultiPortfolioStandardEnGB,

  // Norwegian templates
  helloWorldNbNO,
  advisoryMultiPortfolioStandardNbNO,
];

/** Template categories, in display order. Labels live in the dialog that shows them. */
export const PDF_TEMPLATE_CATEGORIES: readonly PdfTemplateCategory[] = [
  "basic",
  "advisory",
  "execution",
  "reporting",
];
